import { render, staticRenderFns } from "./AddRawMaterialGroupsDialog.vue?vue&type=template&id=b8570ba2"
import script from "./AddRawMaterialGroupsDialog.vue?vue&type=script&lang=ts"
export * from "./AddRawMaterialGroupsDialog.vue?vue&type=script&lang=ts"
import style0 from "./AddRawMaterialGroupsDialog.vue?vue&type=style&index=0&id=b8570ba2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports